import React from 'react';
import { Typography } from '@material-ui/core';
import { makeStyles } from '@material-ui/styles';
import PropTypes from 'prop-types';

const useStyles = makeStyles((theme) => ({
  root: {
    // Same gutters as the heading and the upload box above it.
    padding: `0 ${theme.spacing(3)}px`,
  },
  line: {
    margin: '2px 0',
  },
}));

// Size and format are the same for both logos; only the advice about shape
// differs, and the two halves phrase it differently enough (a range on one, a
// square on the other) that each passes the whole sentence rather than a ratio.
const SpecificheLogo = ({ consiglioRapporto }) => {
  const classes = useStyles();

  return (
    <div className={classes.root}>
      <Typography variant="body2" className={classes.line}>
        La dimensione massima consentita è 150KB.
      </Typography>
      <Typography variant="body2" className={classes.line}>
        I file caricati devono essere in formato JPEG (o JPG) o PNG.
      </Typography>
      <Typography variant="body2" className={classes.line}>
        {consiglioRapporto}
      </Typography>
    </div>
  );
};

SpecificheLogo.propTypes = {
  consiglioRapporto: PropTypes.string.isRequired,
};

export default SpecificheLogo;
